import React, { PureComponent } from 'react';
import Icon from '~/core/scripts/components/icon'

class MapCTA extends PureComponent {
  getMessage() {
    if (this.props.userScore) {
      return null
    }

    if (this.props.errorMessage) {
      return <span className="error-message"><Icon type="sad"/> {this.props.errorMessage}</span>
    }

    return <span>Zeichnen Sie den Verlauf der innerdeutschen Grenze</span>
  }

  render() {
    const ctaMessage = this.getMessage();

    return (
      <div className="map__cta">{ctaMessage}</div>
    );
  }
}

export default MapCTA;

